import React, { FC, useCallback, useMemo } from 'react';
import SidebarView from 'src/shared/InfoSidebar/SidebarView';
import { useCurrentSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import WorkspacePreview from 'src/pages/BidsPage/WorkspacePreview';
import TenderPreview from './TenderPreview';
import MpPreview from './MpPreview';
import { ProcurementsDisplay } from 'src/models/procurements/types';
import useOverviewMode from 'src/reactiveVars/overviewModeVar';
import CallOfPreview from 'src/pages/CallOffsPage/CallOffPreview';
import BidPreview from '../../BidsPage/BidPreview';
import InboxPreview from '../../CallOffsPage/InboxPreview';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import { useLoadMp } from 'src/models/matchingProfiles/hooks';
import { useTranslation } from 'react-i18next';
import { trackMPEditPressCross } from 'src/segment/events';

interface IProps {
  className?: string;
}
const OverviewSidebars: FC<IProps> = ({ className }) => {
  const sidebarState = useCurrentSidebar();
  const procurementTabInfo = useOverviewMode();
  const [{ data: apiTenders, apiVars, vars }] = useApiTenders();
  const { data: mp } = useLoadMp(vars.matchingProfileId);
  const { t } = useTranslation();

  const onClose = useCallback(() => {
    if (sidebarState && sidebarState.mp) {
      const { isMPUpdated, resetMPData } = sidebarState.mp;
      if (mp) {
        trackMPEditPressCross({ id: mp.id, name: mp.name }, isMPUpdated);
      }

      if (isMPUpdated) {
        resetMPData(apiVars);
      }
    }
  }, [sidebarState, mp, apiVars]);

  const shouldUpdate = useMemo(
    () => sidebarState && sidebarState.mode === SidebarMode.MP_INFO && sidebarState.mp,
    [sidebarState]
  );
  const showTooltip = useMemo(
    () => shouldUpdate && sidebarState?.mp?.isMPUpdated,
    [shouldUpdate, sidebarState?.mp?.isMPUpdated]
  );

  return (
    <>
      {sidebarState && (
        <SidebarView
          onClose={shouldUpdate ? onClose : undefined}
          closeBtnTooltip={showTooltip ? t('Tenders.closeAndUpdate') : undefined}
          className={className}
        >
          {sidebarState.mode === SidebarMode.WORKSPACE_INFO &&
            procurementTabInfo &&
            procurementTabInfo.tab === ProcurementsDisplay.WORKSPACE && (
              <WorkspacePreview workspaceId={procurementTabInfo.workspaceId} key={procurementTabInfo.workspaceId} />
            )}
          {sidebarState.mode === SidebarMode.PROCUREMENT_INFO && sidebarState.id && apiTenders && (
            <TenderPreview tenderId={sidebarState.id} />
          )}
          {sidebarState.mode === SidebarMode.MP_INFO && <MpPreview key={sidebarState.id} />}
          {sidebarState.mode === SidebarMode.BID_INFO &&
            procurementTabInfo &&
            procurementTabInfo.tab === ProcurementsDisplay.WORKSPACE &&
            sidebarState.id && <BidPreview key={sidebarState.id} />}
          {sidebarState.mode === SidebarMode.CALL_OFF_INFO && sidebarState.id && (
            <CallOfPreview key={sidebarState.id} />
          )}
          {sidebarState.mode === SidebarMode.INBOX_INFO && sidebarState.id && <InboxPreview key={sidebarState.id} />}
        </SidebarView>
      )}
    </>
  );
};

export default OverviewSidebars;
